import { getStoreValueForParam } from './getStoreValueForParam'

/**
 * Builds initial params from input_schema.properties using store values and defaults.
 * Only includes a key when value is defined. input_image only when inputImage is set.
 * Then adds any allowed key (e.g. from allOf) that has a store value but is not in properties.
 */
export function buildInitialParams(properties, settingsKey, state, topLevelRequired, allowedKeys) {
  const required = new Set(topLevelRequired || [])
  const params = Object.entries(properties || {}).reduce((acc, [key, propSchema]) => {
    const valueFromStore = getStoreValueForParam(key, settingsKey, state)
    const value = valueFromStore !== undefined
      ? valueFromStore
      : propSchema?.default

    if (value === undefined || (key === 'input_image' && valueFromStore === undefined)) {
      return acc
    }

    acc[key] = value
    return acc
  }, {})

  const withRequired = Array.from(required).reduce((acc, key) => {
    if (acc[key] !== undefined) {
      return acc
    }

    const propSchema = properties?.[key]
    const defaultValue = propSchema?.default
    if (defaultValue !== undefined) {
      acc[key] = defaultValue
    }

    return acc
  }, { ...params })

  return Array.from(allowedKeys || []).reduce((acc, key) => {
    if (key in acc) {
      return acc
    }

    const valueFromStore = getStoreValueForParam(key, settingsKey, state)
    if (valueFromStore !== undefined) {
      acc[key] = valueFromStore
    }

    return acc
  }, { ...withRequired })
}
